module.exports = __webpack_public_path__ + "img/企业介绍_愿景.f818866b.png";